import React, { useContext, useEffect, useState } from "react";
import appContext from "../../../../context/app/appContext";
import Select from "react-select";

const EventCategoriesSelector = ({ selectedCategory, onChange }) => {
  const { serverGet } = useContext(appContext);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const getCategories = async () => {
    try {
      const res = await serverGet("/events/categories/all");
      const categories = res.categoryData[0] || [];

      const options = categories
        .filter((cat) => cat.is_active)
        .map((cat) => ({
          value: cat.category_id,
          label: cat.category_name,
        }));

      setCategoryOptions(options);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch categories:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-medium text-gray-700">
        Event Category
      </label>
      <Select
        options={categoryOptions}
        isLoading={loading}
        value={categoryOptions.find((opt) => opt.value === selectedCategory) || null}
        onChange={(selected) =>
          onChange("category", selected ? selected.value : "")
        }
        isClearable
        placeholder="Select event category..."
      />
    </div>
  );
};

export default EventCategoriesSelector;
